module.exports = __webpack_public_path__ + "static/img/02.be9927b9.png";